import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

import InicioPage from '../layouts/Inicio.vue'
import PruebasPage from '../layouts/Examen/Pruebas-Tecnicas.vue'
import AspirantePage from '../layouts/AspirantePage.vue'
import FinExamen from '../layouts/FinExamen.vue'
import LoginPage from '../layouts/LoginPage.vue'
import store from '@/store'
const routes = [
  {
    path: '/:catchAll(.*)',
    redirect: '/login',
    meta: {auth: false}
  },
  {
    path: '/',
    redirect: '/login',
    meta: {auth: false}
  },
  {
    path: '/bienvenida-prueba-tecnica',
    component: InicioPage,
    name:'Bienvenida',
    meta: {auth: true}
  },
  {
    path: '/pruebas',
    component : PruebasPage,
    name:'Pruebas',
    meta: {auth: true}

    },
    {
      path: '/aspirante',
      component : AspirantePage,
      name: 'Aspirante',
      meta: {auth: true}

    },
    {
      path: '/fin-Examen', 
      component : FinExamen,
      name: 'Fin examen',
      meta: {auth: true}

    },
    {
      path: '/login',
      component : LoginPage,
       name: 'Login',
       meta: {auth: false}
    }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
router.beforeEach((to, from, next) => {
  if(to.meta.auth && !store.state.isAuthenticated){
    next('/login');
  }
  else{
    next();
  }
})

export default router;
